import { EmployeeAction, EmployeeState } from 'store/data/employee';
import { domainUtility } from 'utility';

const initialState: EmployeeState = { allIds: [], byId: {} };

const employeeReducer = (
  state: EmployeeState = initialState,
  action: EmployeeAction,
): EmployeeState => {
  switch (action.type) {
    case 'data/employee/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/employee/SET':
      return domainUtility.set(state, action.payload);
    case 'data/employee/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/employee/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/employee/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default employeeReducer;
